import { StyledToolbarButton, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';

import { ToastService } from '../../../../services/toast.service';
import hideIcon from '@ingka/ssr-icon/paths/visibility-hide';
import { theme } from '../../../../shared/styles/core/theme';
import { tokens } from '../../../../shared/styles/core/tokens';
import { useTableDataState } from '../../state/table-data.state';

export const HideInactiveRowsButton = () => {
   const [query, isInactiveHidden] = useTableDataState((state) => [state.query, state.query.inactivatedRowsHidden || false]);

   const onClick = () => {
      useTableDataState.setState({ query: { ...query, inactivatedRowsHidden: !isInactiveHidden } });

      if (!isInactiveHidden) {
         ToastService.success('Inactivated rows are hidden');
      } else {
         ToastService.success('Inactivated rows are showing');
      }
   };

   return (
      <StyledTooltip title={'Hide/Show inactivated rows'}>
         <StyledToolbarButton
            ssrIcon={hideIcon}
            text="Hide/Show inactivated rows"
            iconOnly={true}
            small={true}
            onClick={onClick}
            style={{
               backgroundColor: isInactiveHidden ? theme.colors.border.focus : '',
               color: isInactiveHidden ? theme.colors.text.inverse : '',
               paddingLeft: isInactiveHidden ? '0' : '',
               marginLeft: isInactiveHidden ? tokens.space.sm : ''
            }}
         />
      </StyledTooltip>
   );
};
